import { isJSON } from "@/util/utils";

const SLOT_KEYS = ["img1", "img2", "img3", "img4"];

export function normalizeUploadedImageUrl(path) {
  if (!path || typeof path !== "string") return "";
  const p = path.trim();
  if (/^https?:\/\//i.test(p)) return p;
  const base = "https://hzshixiang.site";
  return p.startsWith("/") ? base + p : `${base}/${p}`;
}

export function parseRealPictureUrls(raw) {
  if (raw == null || raw === "") return [];

  let parsed = raw;
  if (typeof raw === "string") {
    if (!isJSON(raw)) return [];
    parsed = JSON.parse(raw);
  }

  if (Array.isArray(parsed)) {
    return parsed.map((v) => (v != null ? String(v).trim() : "")).filter(Boolean);
  }

  if (typeof parsed === "object") {
    const ordered = SLOT_KEYS.map((k) => parsed[k]).filter(Boolean);
    if (ordered.length) return ordered.map(String);
    return Object.values(parsed)
      .map((v) => (v != null ? String(v).trim() : ""))
      .filter(Boolean);
  }

  return [];
}

/** 鉴别报告模板仍使用 4 个固定槽位，取前 4 张 */
export function realPictureUrlsToSlots(urls) {
  const list = Array.isArray(urls) ? urls : parseRealPictureUrls(urls);
  return {
    img1: list[0] || "",
    img2: list[1] || "",
    img3: list[2] || "",
    img4: list[3] || "",
  };
}

/** 报告生成加载图片：与 atlas 等字段一致，去掉域名前缀供 getImgBase64Fn 使用 */
export function realPicturePathForReportLoad(path) {
  if (!path) return "";
  const normalized = normalizeUploadedImageUrl(String(path).trim());
  return normalized.replace("https://hzshixiang.site", "");
}



// WEBPACK FOOTER //
// ./src/util/orderRealPicture.js